import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Card,
    CardContent,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    Checkbox,
    TableContainer,
    Box,
    CircularProgress,
    Button
} from "@material-ui/core";
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from "@material-ui/icons/Refresh";
import FilterListIcon from "@material-ui/icons/FilterList";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import { useDispatch } from "react-redux";
import { setIDSOData } from "../../redux/actions/leadSourceActions";
import { DownloadOutlined } from '@ant-design/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    headerCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 600,
        textAlign: "center",
        position: "sticky",
        top: 0,
        zIndex: 2
    },
    cell: {
        textAlign: "center",
        fontWeight: 600,
        background: "#1e3a8a",
        color: "#fff",
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa"
        },
        "&:hover": {
            backgroundColor: "#eef2ff"
        }
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const InternalDSOStageSummary = (props) => {
    const classes = useStyles();
    const idsoData = useSelector((state) => state.leadSource.idsoData);
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("internalDSO")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [internalDesignSignOffTableCsvData, setInternalDesignSignOffTableCsvData] = useState([]);
    const internalDesignSignOffTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const [storeUserGroupDetails, setUserGroupDetails] = useState([])
    const [showNewTable, setShowNewTable] = useState(false); // For toggling the table visibility
    const [groupedTable, setGroupedTable] = useState([])
    const [groups, setGroups] = useState([]);
    const [storeHeadings, setStoreHeadings] = useState([])
    const [storeRowsData, setStoreRowsData] = useState([])
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [dynamicDataShow, setDynamicDataShow] = useState(0)

    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const TWELFTH_BUTTON_DISABLE_UNTIL_KEY = 'twelfthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [loading, setLoading] = useState(false);

    const displayDate = (month, year) => {
        const shortYear = year.toString().slice(-2); // Get the last two digits of the year

        // Check if the month includes a `/`, indicating multiple months
        if (typeof month === 'string' && month.includes('/')) {
            const monthCodes = month.split('/').map(code => parseInt(code)); // Convert each to an integer
            monthCodes.sort((a, b) => a - b); // Sort the month codes in ascending order
            const monthNames = monthCodes.map(code => months[code]); // Convert each code to month name
            return `${monthNames.join('/')} - ${shortYear}`; // Join with a slash and append the short year
        } else {
            // Single month case
            return `${months[parseInt(month)]} - ${shortYear}`;
        }
    };

    const clickableCellStyle = (index) => ({
        textAlign: "center",
        cursor: "pointer",
        color: index !== store.length - 1 ? "#1C375D" : "#355025",
        textDecoration: "underline",
        fontWeight: index !== store.length - 1 ? 'normal' : 'bolder',
        background: "white"
    });

    const grandTotalCellStyle = {
        textAlign: "center",
        cursor: "pointer",
        color: "#004d40",
        textDecoration: "underline",
        fontWeight: "bolder",
        background: "white"
    };

    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            internalDSOSummary()
            setSelectedRole(ROLENAME.SalesUser)
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            internalDSOSummary()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            setSelectedRole("ALL")
            internalDSOSummary();
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "designUser", label: "Design User" },
        { key: "designAssistantManager", label: "Design Assistant Manager" },
        { key: "designManager", label: "Design Manager" },
        { key: "designDGM", label: "Design DGM" },
        { key: "currentStage", label: "Current Stage" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "staticSalesWonBudget", label: "Saleswon Value" },
        { key: "staticDesignWonBudget", label: "Designwon Value" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "internalDesignSignOffDate", label: "Internal Design Sign-Off Date" },
        { key: "tokenPercent", label: "Token % Received" },
    ];

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "value", label: "Value (INR)" },
        { key: "currentStage", label: "Current Stage" },
        { key: "city", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "internalDesignSignOffDate", label: "Internal Design Sign-Off Date" },
        { key: "tokenPercent", label: "Token % Received" },
    ];

    // Trigger CSV download when data is ready
    useEffect(() => {
        if (triggerDownload && internalDesignSignOffTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (internalDesignSignOffTableCsvButtonRef.current?.link) {
                    try {
                        internalDesignSignOffTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDownload(false);
                } else {
                    // Retry if link is not ready
                    setTimeout(() => {
                        if (internalDesignSignOffTableCsvButtonRef.current?.link) {
                            internalDesignSignOffTableCsvButtonRef.current.link.click();
                            setTriggerDownload(false);
                        }
                    }, 200);
                }
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [triggerDownload, internalDesignSignOffTableCsvData]);

    // Function to generate CSV data for internal design sign-off table
    const generateInternalDesignSignOffTableCsvData = () => {
        try {
            if (!store || store.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row - match table structure exactly
            const headerRow = {
                "Internal DSO Month And Year": "",
                "Internal DSO Stage - Count": "",
                "Internal DSO Stage - Value": "",
                "DSO Rejected - Count": "",
                "DSO Rejected - Value": "",
                "QC Approval - Count": "",
                "QC Approval - Value": "",
                "QCManager Approval - Count": "",
                "QCManager Approval - Value": "",
                "ADM Approval - Count": "",
                "ADM Approval - Value": "",
                "DGM Approval - Count": "",
                "DGM Approval - Value": "",
                "Customer Approval - Count": "",
                "Customer Approval - Value": "",
                "Design Sign-Off Hold - Count": "",
                "Design Sign-Off Hold - Value": "",
                "Design Sign-Off Completed - Count": "",
                "Design Sign-Off Completed - Value": "",
                "Grand Total - Count": "",
                "Grand Total - Value": ""
            };
            csvRows.push(headerRow);

            // Add data rows for each month/year
            store.forEach((ele) => {
                const row = {
                    "Internal DSO Month And Year": ele.month === store.length - 1
                        ? ele?._id?.year
                        : `${months[ele?.month]}-${ele?._id?.year % 100}`,
                    "Internal DSO Stage - Count": ele.internalDSOCount || 0,
                    "Internal DSO Stage - Value": formatNumberToTwoDecimalPlaces(ele.internalDSO || 0),
                    "DSO Rejected - Count": ele.dsoRejectedCount || 0,
                    "DSO Rejected - Value": formatNumberToTwoDecimalPlaces(ele.dsoRejected || 0),
                    "QC Approval - Count": ele.QCApprovalCount || 0,
                    "QC Approval - Value": formatNumberToTwoDecimalPlaces(ele.QCApproval || 0),
                    "QCManager Approval - Count": ele.QCManagerApprovalCount || 0,
                    "QCManager Approval - Value": formatNumberToTwoDecimalPlaces(ele.QCManagerApproval || 0),
                    "ADM Approval - Count": ele.ADMApprovalCount || 0,
                    "ADM Approval - Value": formatNumberToTwoDecimalPlaces(ele.ADMApproval || 0),
                    "DGM Approval - Count": ele.DGMApprovalCount || 0,
                    "DGM Approval - Value": formatNumberToTwoDecimalPlaces(ele.DGMApproval || 0),
                    "Customer Approval - Count": ele.customerApprovalCount || 0,
                    "Customer Approval - Value": formatNumberToTwoDecimalPlaces(ele.customerApproval || 0),
                    "Design Sign-Off Hold - Count": ele.dsoHoldCount || 0,
                    "Design Sign-Off Hold - Value": formatNumberToTwoDecimalPlaces(ele.dsoHold || 0),
                    "Design Sign-Off Completed - Count": ele.completedCount || 0,
                    "Design Sign-Off Completed - Value": formatNumberToTwoDecimalPlaces(ele.completed || 0),
                    "Grand Total - Count": ele.totalCount || 0,
                    "Grand Total - Value": formatNumberToTwoDecimalPlaces(ele.grandTotal || 0)
                };
                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating internal design sign-off table CSV:", error);
            return [];
        }
    };

    const generateTableCsv = () => {
        try {
            let csvArray = [];
            if (popMonthData && popMonthData.length > 0) {
                popMonthData.forEach((data, i) => {
                    const value = data.staticDesignWonBudget || data.staticSalesWonBudget || 0;
                    let obj = {
                        serialNo: i + 1,
                        projectCode: data?.erpProjectNo || "NA",
                        leadNumber: data?.lead_no || "NA",
                        clientName: data?.customerName || "N/A",
                        value: value ? value.toFixed(2) : "N/A",
                        currentStage: data?.currentStage || "N/A",
                        city: data?.locationName || "N/A",
                        expCtrName: data?.experienceCenterName || "N/A",
                        salesWonDate: data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-",
                        internalDesignSignOffDate: data?.internalDesignSignOffDate ? moment(data?.internalDesignSignOffDate).format("DD-MM-YYYY") : "-",
                        tokenPercent: data?.tokenPercent !== null ? data?.tokenPercent : "null",
                    };
                    csvArray.push(obj);
                });
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            }, 100);
        } catch (error) {
            console.error("Error generating table CSV:", error);
            props?.setSnackInfo("Error generating table CSV", "error");
        }
    };



    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerName,
                    totalValue: popMonthData[i]?.staticDesignWonBudget
                        ? popMonthData[i].staticDesignWonBudget
                        : (popMonthData[i]?.staticSalesWonBudget ?? "N/A"),
                    staticSalesWonBudget : popMonthData[i]?.staticSalesWonBudget ?? "N/A",
                    staticDesignWonBudget : popMonthData[i]?.staticDesignWonBudget ?? "N/A",
                    location: popMonthData[i]?.locationName,
                    expCtrName: popMonthData[i]?.experienceCenterName,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designUser: popMonthData[i]?.designUserName ? popMonthData[i]?.designUserName : 'NA',
                    designManager: popMonthData[i]?.designManagerName ? popMonthData[i]?.designManagerName : 'NA',
                    designDGM: popMonthData[i]?.designDGMName ? popMonthData[i]?.designDGMName : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManagerName ? popMonthData[i]?.designAssistantManagerName : 'NA',
                    currentStage: popMonthData[i]?.currentStage ? popMonthData[i]?.currentStage : 'NA',
                    internalDesignSignOffDate: popMonthData[i]?.internalDesignSignOffDate
                        ? moment(popMonthData[i]?.internalDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    tokenPercent: popMonthData[i]?.tokenPercent !== null ? popMonthData[i]?.tokenPercent : "null",
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {

            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const internalDSOSummary = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let currentObj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            currentObj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            currentObj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            currentObj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        // try {
        //     let response = await HttpService.internalDSOSummaryDashboard(currentObj);
        //     setStore(response.data.data);
        // } catch (error) {
        //     props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        // }
        let shouldMakeApiCall = false;

        // Case 1: No idsoData - must call API
        if (!idsoData || idsoData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.internalDSOSummaryDashboard(currentObj);
                setStore(response.data.data);
                dispatch(setIDSOData(response.data.data));
            } else {
                // Use existing data
                setStore(idsoData);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        setLoading(false);
    }

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(TWELFTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(TWELFTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(TWELFTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(TWELFTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    const getRefreshedData = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        setLoading(true);
        try {
            let response = await HttpService.internalDSOSummaryDashboard(obj);
            setStore(response.data.data);
            dispatch(setIDSOData(response.data.data));
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = async () => {
        internalDSOSummary(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)

    }

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            tokenPercentage: event.target.value !== "" ? event.target.value : "",
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        setLoading(true);
        try {
            let users = ''
            if (selectedUsers && selectedUsers.length !== 0) {
                users = selectedUsers?.map((el) => el._id)
            }
            obj.users = users ? users : ""
            obj.selectedRole = selectedRole
            let response = await HttpService.internalDSOSummaryDashboard(obj);
            setStore(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        internalDSOSummary(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)


    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            if (!role) {
                await internalDSOSummary(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
            }
            setUsersData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error, "error")
        }
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newvalue) => {
        setLoading(true);
        await internalDSOSummary(newvalue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        setLoading(false);
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        await internalDSOSummary(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        setLoading(false);
    }

    const dataBasedOnClick = async (data, text) => {
        setShowDetailedModal(true);
        setPopMonthData(data);
    }

    const clearDateFilter = async () => {
        setSearchInput("")
        setSelectedSearchType("")
        internalDSOSummary(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }

    const handleExpData = async (newvalue) => {
        setLoading(true);
        await internalDSOSummary(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)
        setLoading(false);
    }

    return (
        <div className="App">
            <br />

            <div>
                <Card
                    style={{
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        marginBottom: "16px"
                    }}
                >
                    <CardContent style={{ padding: "16px 20px" }}>

                        {/* HEADER */}
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            style={{ marginBottom: "12px" }}
                        >
                            <Grid
                                item
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                }}
                            >
                                <FilterListIcon style={{ color: "#1C375D", fontSize: "20px" }} />

                                <h2
                                    style={{
                                        margin: 0,
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        color: "#1C375D"
                                    }}
                                >
                                    Filters
                                </h2>
                            </Grid>
                        </Grid>

                        <Paper className={classes.paper} elevation={0} style={{ padding: "10px 0" }}>
                            <Grid
                                container
                                spacing={2}
                                justifyContent={
                                    userDetails?.roles && userDetails.roles.some(role =>
                                        [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                                    )
                                        ? "flex-start"
                                        : "center"
                                }
                                alignItems="center"
                                wrap="nowrap"  // Prevents wrapping to the next line, keeps everything in one row
                            >
                                {userDetails?.roles &&
                                    userDetails.roles.some((role) =>
                                        [ROLENAME.AGM_Design, ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                                    ) && (
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedLocation}
                                                    onChange={handleMultipleLocationData}
                                                    options={commonLocation}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Location"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                {userDetails?.roles &&
                                    userDetails.roles.some((role) =>
                                        [ROLENAME.AGM_Design, ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser, ROLENAME.DGM_Sales].includes(role.name)
                                    ) && (
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedExperienceCenter}
                                                    onChange={handleMultipleExpData}
                                                    options={commonExpCenter}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Exp-Center"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        id="startDate"
                                        name="startDate"
                                        label="Internal DSO Start Date"
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        value={storeDateFilter.startDate}
                                        onChange={storePivotDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        id="endDate"
                                        name="endDate"
                                        label="Internal DSO End Date"
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        value={storeDateFilter.endDate}
                                        onChange={storePivotDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        size="small"
                                        onClick={handlePivotDateFilter}
                                        style={{
                                            backgroundColor: "#F47E46",
                                            color: "#fff",
                                            height: "40px",
                                            borderRadius: "6px",
                                            textTransform: "none",
                                            fontWeight: 500
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item xs={12} sm={2}>
                                    <FormControl style={{ width: '70%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="50 % Payment"
                                            variant="outlined"
                                            size="small"
                                            value={selectedValue}
                                            onChange={(e) => handleSelectChange(e)}
                                        >
                                            <MenuItem value="2">All</MenuItem>
                                            <MenuItem value="1">YES</MenuItem>
                                            <MenuItem value="0">NO</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.DGM_Design, ROLENAME.AGM_Design, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                >
                                                    {/* Create an array of MenuItem elements instead of using a fragment */}
                                                    {[
                                                        <MenuItem key="ALL" value="ALL">ALL</MenuItem>,
                                                        ...(userDetails.departmentId === salesDepartment ? [
                                                            <MenuItem key={ROLENAME.DGM_Sales} value={ROLENAME.DGM_Sales}>DGM Sales</MenuItem>,
                                                            <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                        ] : [
                                                            <MenuItem key={ROLENAME.DGM_Design} value={ROLENAME.DGM_Design}>DGM Design</MenuItem>,
                                                            <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                            // <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                        ])
                                                    ]}
                                                </TextField>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager, ROLENAME.OperationDesignManager].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                >
                                                    {/* Create an array of MenuItem elements instead of using a fragment */}
                                                    {[
                                                        ...(userDetails.departmentId === salesDepartment ? [
                                                            <MenuItem key={ROLENAME.SalesManager} value={ROLENAME.SalesManager}>Sales Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                        ] : [
                                                            <MenuItem key={ROLENAME.OperationDesignManager} value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>,
                                                            // <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                        ])
                                                    ]}
                                                </TextField>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager, ROLENAME.AssistantDesignManager].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                >
                                                    {/* Create an array of MenuItem elements instead of using a fragment */}
                                                    {[
                                                        ...(userDetails.departmentId === salesDepartment ? [
                                                            <MenuItem key={ROLENAME.AssistantSalesManager} value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.SalesUser} value={ROLENAME.SalesUser}>Executive</MenuItem>
                                                        ] : [
                                                            // <MenuItem key={ROLENAME.AssistantDesignManager} value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>,
                                                            <MenuItem key={ROLENAME.DesignUser} value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                        ])
                                                    ]}
                                                </TextField>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    size="medium"
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                                {/* Search Type Dropdown */}
                                <TextField
                                    select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedSearchType}
                                    label="Search Type"
                                    name="searchType"
                                    onChange={(e) => handleSearchType(e.target.value)}
                                    variant="outlined"
                                    style={{ width: '30%', marginRight: '2%' }}
                                    size="small"
                                >
                                    {searchTypes && searchTypes?.map((el, index) => (
                                        <MenuItem key={index} value={el}>{el}</MenuItem>
                                    ))}
                                </TextField>

                                {/* Search Input */}
                                <TextField
                                    label="Enter the input"
                                    name="searched"
                                    size="small"
                                    value={searchInput}
                                    onChange={(e) => { setSearchInput(e.target.value) }}
                                    onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                                    variant="outlined"
                                    style={{ width: '80%' }}
                                />

                                {/* Search Button */}
                                <Button
                                    disabled={!selectedSearchType || !searchInput}
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    style={{ alignSelf: "center", marginLeft: 20 }}
                                    className={classes.leadSearchButton}
                                    onClick={() => handleSearch(searchInput.toUpperCase())}
                                >
                                    Search
                                </Button>

                                {/* Clear Filter Button */}
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    style={{ marginLeft: 10 }}
                                    className={classes.leadClearButton}
                                    onClick={clearDateFilter}
                                >
                                    Clear Filter
                                </Button>
                            </div>
                        </Paper>
                    </CardContent>
                </Card>
            </div>
            <br />

            <div style={{ marginTop: '30px' }}>
                <Paper
                    elevation={4}
                    style={{
                        padding: "20px",
                        borderRadius: "12px",
                        transition: "0.3s ease",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)"}
                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = ""}
                >

                    {/* HEADER CARD */}
                    <Card
                        style={{
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            marginBottom: "16px"
                        }}
                    >
                        <CardContent style={{ padding: "16px 20px" }}>
                            <Grid container alignItems="center" justifyContent="space-between">

                                {/* LEFT */}
                                <Grid item style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <AssessmentIcon style={{ color: "#1C375D" }} />
                                    <h2 style={{ margin: 0, fontWeight: 600, fontSize: "18px" }}>
                                        Internal DSO Dashboard
                                    </h2>
                                </Grid>

                                {/* RIGHT */}
                                <Grid item style={{ display: "flex", gap: "10px" }}>

                                    <Button
                                        onClick={handleRefreshClick}
                                        variant="contained"
                                        startIcon={<RefreshIcon />}
                                        disabled={isDisabled}
                                        style={{
                                            backgroundColor: isDisabled ? "#ccc" : "#F47E46",
                                            color: "#fff",
                                            height: "36px",
                                            textTransform: "none"
                                        }}
                                    >
                                        {isDisabled ? `Wait (${formatTimeLeft()})` : "Fetch New Data"}
                                    </Button>

                                    <CSVLink
                                        data={internalDesignSignOffTableCsvData}
                                        filename={`Internal_DSO_${moment().format('YYYY-MM-DD')}.csv`}
                                        ref={internalDesignSignOffTableCsvButtonRef}
                                        style={{ display: "none" }}
                                    />

                                    <Button
                                        variant="contained"
                                        startIcon={<DownloadOutlined />}
                                        style={{
                                            backgroundColor: "#355025",
                                            color: "#fff",
                                            height: "36px",
                                            textTransform: "none"
                                        }}
                                        onClick={() => {
                                            const csvData = generateInternalDesignSignOffTableCsvData();

                                            if (csvData.length > 0) {
                                                setInternalDesignSignOffTableCsvData(csvData);
                                                setTimeout(() => {
                                                    setTriggerDownload(true);
                                                }, 100);
                                            } else {
                                                props?.setSnackInfo("No data available to export", "warning");
                                            }
                                        }}
                                    >
                                        Download CSV
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    {/* TABLE */}
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        {loading ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "300px",
                                flexDirection: "column",
                                gap: "10px"
                            }}>
                                <CircularProgress />
                                <span>Loading data...</span>
                            </div>
                        ) : (
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '10px' }}>
                                <Table style={{ minWidth: '600px' }}>

                                    {/* HEADER */}
                                    <TableHead className={classes.headerCell} style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <TableRow>
                                            <TableCell className={classes.cell} rowSpan={2}>Internal DSO Month And Year</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>Internal DSO Stage</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>DSO Rejected</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>QC Approval</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>QCManager Approval</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>ADM Approval</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>DGM Approval</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>Customer Approval</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>Design Sign-Off Hold</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>Design Sign-Off Completed</TableCell>
                                            <TableCell className={classes.cell} colSpan={2}>Grand Total</TableCell>
                                        </TableRow>

                                        <TableRow>
                                            {[...Array(10)].map((_, i) => (
                                                <React.Fragment key={i}>
                                                    <TableCell className={classes.cell} >Count</TableCell>
                                                    <TableCell className={classes.cell} >Value</TableCell>
                                                </React.Fragment>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    {/* BODY */}
                                    <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store.length > 0 ? (
                                            store.map((ele, index) => (
                                                <TableRow key={index}>
                                                    {index === store.length - 1 ? (
                                                        <TableCell
                                                            className={classes.cell}
                                                            style={{
                                                                fontSize: '15px',
                                                                fontWeight: 'bolder',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <strong>{ele?._id?.year}</strong>
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell
                                                            className={classes.cell}
                                                            style={{
                                                                fontSize: '13px',
                                                                fontWeight: 'normal',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <strong>{months[ele?.month]}-{ele?._id?.year % 100}</strong>
                                                        </TableCell>
                                                    )}

                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.internalDSOData, "internalDSO")} style={clickableCellStyle(index)}>
                                                        {ele.internalDSOCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.internalDSOData, "internalDSO")} style={clickableCellStyle(index)}>
                                                        {(ele.internalDSO)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.dsoRejectedData, "dsoRejected")} style={clickableCellStyle(index)}>
                                                        {ele.dsoRejectedCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.dsoRejectedData, "dsoRejected")} style={clickableCellStyle(index)}>
                                                        {(ele.dsoRejected)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.QCApprovalData, "QCApproval")} style={clickableCellStyle(index)}>
                                                        {ele.QCApprovalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.QCApprovalData, "QCApproval")} style={clickableCellStyle(index)}>
                                                        {(ele.QCApproval)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.QCManagerApprovalData, "QCManagerApproval")} style={clickableCellStyle(index)}>
                                                        {ele.QCManagerApprovalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.QCManagerApprovalData, "QCManagerApproval")} style={clickableCellStyle(index)}>
                                                        {(ele.QCManagerApproval)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.ADMApprovalData, "ADMApproval")} style={clickableCellStyle(index)}>
                                                        {ele.ADMApprovalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.ADMApprovalData, "ADMApproval")} style={clickableCellStyle(index)}>
                                                        {(ele.ADMApproval)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.DGMApprovalData, "DGMApproval")} style={clickableCellStyle(index)}>
                                                        {ele.DGMApprovalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.DGMApprovalData, "DGMApproval")} style={clickableCellStyle(index)}>
                                                        {(ele.DGMApproval)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.customerApprovalData, "customerApproval")} style={clickableCellStyle(index)}>
                                                        {ele.customerApprovalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.customerApprovalData, "customerApproval")} style={clickableCellStyle(index)}>
                                                        {(ele.customerApproval)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.dsoHoldData, "dsoHold")} style={clickableCellStyle(index)}>
                                                        {ele.dsoHoldCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.dsoHoldData, "dsoHold")} style={clickableCellStyle(index)}>
                                                        {(ele.dsoHold)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.completedData, "completed")} style={clickableCellStyle(index)}>
                                                        {ele.completedCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.completedData, "completed")} style={clickableCellStyle(index)}>
                                                        {(ele.completed)?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.grandTotalData, "total")} style={grandTotalCellStyle}>
                                                        {ele.totalCount}
                                                    </TableCell>
                                                    <TableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.grandTotalData, "total")} style={grandTotalCellStyle}>
                                                        {(ele.grandTotal)?.toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={21} align="center">
                                                    No Data Available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        )}
                    </div>
                </Paper>
            </div>

            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: "10px" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>Sales Won Value (INR)</StyledTableCell>
                                    <StyledTableCell>Design Won Value (INR)</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Internal Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Token % Received</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.leadId?.erpProjectNo || "N/A"} */}

                                                {
                                                    data?.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.erpProjectNo}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {
                                                    data?.lead_no ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.lead_no}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerName}
                                            </StyledTableCell>
                                            {
                                                <>
                                                    <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                        {data.staticDesignWonBudget
                                                            ? data?.staticDesignWonBudget?.toLocaleString("en-IN", {
                                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                                style: "currency",
                                                                currency: "INR",
                                                            })
                                                            : data?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                                style: "currency",
                                                                currency: "INR",
                                                            })
                                                        }
                                                    </StyledTableCell>
                                                </>
                                            }

                                            {
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data.staticSalesWonBudget
                                                        ? data?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                            maximumFractionDigits: 2, // Maximum number of decimal places
                                                            style: "currency",
                                                            currency: "INR",
                                                        })
                                                        : "NA"
                                                    }
                                                </StyledTableCell>

                                            }

                                            {<StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                {data.staticDesignWonBudget
                                                    ? data?.staticDesignWonBudget?.toLocaleString("en-IN", {
                                                        maximumFractionDigits: 2, // Maximum number of decimal places
                                                        style: "currency",
                                                        currency: "INR",
                                                    })
                                                    : "NA"
                                                }
                                            </StyledTableCell>}
                                            <StyledTableCell>
                                                {data?.currentStage}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.locationName}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.experienceCenterName}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.internalDesignSignOffDate
                                                    ? moment(data?.internalDesignSignOffDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.tokenPercent !== null ? data?.tokenPercent : "null"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(InternalDSOStageSummary);
